import React from "react";

export const RPGGameClanStorageIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.45 6.87485H2.5575C2.475 6.87485 2.4075 6.94516 2.4075 7.03111L2.40563 7.96865C2.40563 8.05459 2.47313 8.12491 2.55563 8.12491H9.45C9.5325 8.12491 9.6 8.05459 9.6 7.96865V7.03111C9.6 6.94516 9.5325 6.87485 9.45 6.87485ZM9.45 8.74994H2.55188C2.46938 8.74994 2.40188 8.82026 2.40188 8.9062L2.4 9.84374C2.4 9.92968 2.4675 10 2.55 10H9.45C9.5325 10 9.6 9.92968 9.6 9.84374V8.9062C9.6 8.82026 9.5325 8.74994 9.45 8.74994ZM9.45 4.99976H2.56125C2.47875 4.99976 2.41125 5.07007 2.41125 5.15601L2.40938 6.09356C2.40938 6.1795 2.47688 6.24982 2.55938 6.24982H9.45C9.5325 6.24982 9.6 6.1795 9.6 6.09356V5.15601C9.6 5.07007 9.5325 4.99976 9.45 4.99976ZM11.4469 2.28478L6.345 0.0717821C6.23534 0.0243929 6.11778 0 5.99906 0C5.88034 0 5.76279 0.0243929 5.65313 0.0717821L0.553125 2.28478C0.219375 2.43127 0 2.77113 0 3.15006V9.84374C0 9.92968 0.0675 10 0.15 10H1.65C1.7325 10 1.8 9.92968 1.8 9.84374V4.99976C1.8 4.65599 2.07375 4.37473 2.41125 4.37473H9.58875C9.92625 4.37473 10.2 4.65599 10.2 4.99976V9.84374C10.2 9.92968 10.2675 10 10.35 10H11.85C11.9325 10 12 9.92968 12 9.84374V3.15006C12 2.77113 11.7806 2.43127 11.4469 2.28478Z" />
    </svg>
  );
};

export default RPGGameClanStorageIcon;
